import { useCookieStorage } from "@allwyn/storage/composables/use-storage";
type NotificationTime = "full-time" | "close-time" | "seating-time";

const hidingAnimationDuration = 300;

function setHidingCookie(notificationId: string, isPermanent: boolean) {
    useCookieStorage().setItem(
        `notification-${notificationId}`,
        "hide",
        "essential",
        isPermanent ? { expires: Date.now() + 365 * 24 * 60 * 60 * 1000 } : undefined
    );
}

function updateNotificationHeight(notificationText: HTMLElement) {
    const root = document.documentElement;
    const mediaQuery = window.matchMedia("(max-width: 480px)");

    function calculateDynamicHeight() {
        const notificationTextHeight = notificationText.getBoundingClientRect().height;

        if (notificationTextHeight > 64 && mediaQuery.matches) {
            root.style.setProperty("--notification-height", `${notificationTextHeight}px`);
        } else {
            root.style.removeProperty("--notification-height");
        }
    }

    mediaQuery.addEventListener("change", calculateDynamicHeight, { passive: true });
    calculateDynamicHeight();
}

function hideNotification(notification: HTMLElement) {
    document.body.classList.remove("has-notification");
    notification.classList.remove("active");
    notification.classList.add("hiding");
    document.documentElement.style.removeProperty("--notification-height");

    window.setTimeout(() => {
        notification.style.display = "none";
    }, hidingAnimationDuration);
}

export function useGlobalNotification() {
    if (window.environment.isEditMode) return;

    const notification = document.querySelector<HTMLElement>(".sazka-notification");

    if (!notification) return;

    const notificationId = notification.dataset.id;
    const notificationTime = notification.dataset.time as NotificationTime | undefined;
    const notificationText = document.getElementById("sazka-notification-text");

    if (!notificationId || !notificationTime || !notificationText) return;

    if (notificationTime === "seating-time") {
        setHidingCookie(notificationId, false);
    }

    updateNotificationHeight(notificationText);

    notification.querySelector(".sazka-notification__close")?.addEventListener("click", () => {
        setHidingCookie(notificationId, notificationTime === "close-time");
        hideNotification(notification);
    });
}
